import axios from 'axios';
// const BASE_URL = 'http://localhost:1337';
const BASE_URL = 'https://viewnet-admin.link/';


export default axios.create({
    baseURL: BASE_URL
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});
